import "react-app-polyfill/ie11";
//  import 'react-app-polyfill/stable';
import React, { Component } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import CSVReader from 'react-csv-reader';
import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/stable";
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-confirm-alert/src/react-confirm-alert.css";

// import 'react-app-polyfill/ie11'; // For IE 11 support
// import "./polyfill";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
